import { API_URL } from "config";
import Http from "util/https";
import Notify from "config/notify";
import { OrderCheck } from "../types";

type Arg = {
  orderList: OrderCheck[];
};

/**
 * 注文を確定するAPI
 * @param orderList 注文情報
 */
export default async function updateOrderApi({ orderList }: Arg) {
  console.log("updateOrder:", orderList);

  const params = {
    // ToDo: client_cdは必要とあるが、選択したものの中には複数client_cdがあるため、もし必須であればorder_build_nosをclient_cdに分けて複数回叩く必要がある。
    operation: 0,
    order_build_nos: orderList.map(o => o.orderNumber)
  }

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/product/publish`;
  const res = await http.post<{messages: string[]}>(url, params);
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};
  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
  return res.data.messages.join('\n');
}
